module.exports = __webpack_public_path__ + "static/media/epark-star.fb3cc26a.svg";